import React, { useState, useEffect } from "react";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { StyledDataGrid } from "../../../../common/components/DataGrid/styles";
import { StyledButton } from "../../../../common/components/Button";
import AddModeOfPaymentDialog from "./AddModeOfPaymentDialog";
import { StyledH2 } from "../../../../common/components/Title/styles";
import UpdateModeOfPaymentDialog from "./UpdateModeOfPaymentDialog";
import { deleteModeOfPayment } from "../../../../api/modeOfPaymentApi";
import { getAllModeOfPayments } from "../../../../api/modeOfPaymentApi";
import ConfirmationDialog from "../../../../common/components/Dialog";
const ModeOfPaymentsTable = ({ theme }) => {
  const [openAddModeOfPayment, setOpenAddModeOfPayment] = useState(false);
  const [openUpdateModeOfPayment, setOpenUpdatelignerMaterial] =
    useState(false);
  const [rows, setRows] = useState([]);
  const [currentModeOfPayment, setCurrentModeOfPayment] = useState({});
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [confirmationSubmit, setConfirmationSubmit] = useState(
    () => () => null
  );
  useEffect(() => {
    fetchModeOfPayments();
  }, []);

  const fetchModeOfPayments = async () => {
    const response = await getAllModeOfPayments();
    console.log(response);
    setRows([...response]);
  };

  const handleOpenAddModeOfPayment = () => {
    setOpenAddModeOfPayment(true);
  };

  const handleCloseAddModeOfPayment = () => {
    setOpenAddModeOfPayment(false);
  };
  //Update
  const handleOpenUpdateModeOfPayment = (event, params) => {
    event.stopPropagation();
    setCurrentModeOfPayment({ ...params.row });
    setOpenUpdatelignerMaterial(true);
  };
  const handleCloseUpdateModeOfPayment = () => {
    setOpenUpdatelignerMaterial(false);
  };

  const handleDeleteModeOfPayment = async (id) => {
    await deleteModeOfPayment({ Id: id });
    await fetchModeOfPayments();
  };

  const columns = [
    { field: "name", headerName: "Mode of Payment", flex: 1 },
    {
      field: "col5",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => {
        return [
          <GridActionsCellItem
            icon={<FontAwesomeIcon icon={faPen} />}
            label="Update"
            onClick={(e) => handleOpenUpdateModeOfPayment(e, params)}
          />,
          <GridActionsCellItem
            icon={<FontAwesomeIcon icon={faTrash} />}
            label="Delete"
            onClick={(e) => {
              e.stopPropagation();
              setShowConfirmationDialog(true);
              setConfirmationSubmit(() => () => {
                handleDeleteModeOfPayment(params.id);
                setShowConfirmationDialog(false);
              });
            }}
          />,
        ];
      },
    },
  ];

  return (
    <div>
      <StyledH2 theme="purple">Modes of Payment</StyledH2>
      {/* <StyledButton onClick={handleOpenAddModeOfPayment} theme="green">
        <FontAwesomeIcon icon={faPlus} style={{ paddingRight: "3px" }} />
        Add mode of payment
      </StyledButton> */}

      <AddModeOfPaymentDialog
        openAddModeOfPayment={openAddModeOfPayment}
        handleCloseAddModeOfPayment={handleCloseAddModeOfPayment}
        currentModeOfPayment={currentModeOfPayment}
        fetchModeOfPayments={fetchModeOfPayments}
      />
      <UpdateModeOfPaymentDialog
        openUpdateModeOfPayment={openUpdateModeOfPayment}
        handleCloseUpdateModeOfPayment={handleCloseUpdateModeOfPayment}
        currentModeOfPayment={currentModeOfPayment}
        fetchModeOfPayments={fetchModeOfPayments}
      />
      <ConfirmationDialog
        open={showConfirmationDialog}
        handleClose={() => setShowConfirmationDialog(false)}
        submit={confirmationSubmit}
        title={"Delete mode of payment?"}
      />
      <StyledDataGrid
        autoHeight
        rows={rows}
        columns={columns}
        pageSize={50}
        rowsPerPageOptions={[]}
      />
    </div>
  );
};

export default ModeOfPaymentsTable;
